import type { ReactNode } from 'react'
import { Icon } from './Icon'

// Enlace a otra web (Visit, Reforestación…): se abre aparte para no perder la app, y el icono
// avisa de que se sale de ella.
export const ExternalLink = ({ href, children }: { href: string; children: ReactNode }) => (
	<a
		href={href}
		target="_blank"
		rel="noopener noreferrer"
		className="inline-flex min-h-12 items-center gap-2 font-semibold text-forest-800 underline underline-offset-4"
	>
		{children}
		<Icon name="external" className="size-5 shrink-0" />
	</a>
)
